import { GlobalLayout as AutoDispatchGlobal } from "~/features/auto-dispatch/layout/global-layout.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const AutoDispatchGlobalPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlAutoDispatchAdmin");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? (
		<AutoDispatchGlobal />
	) : (
		<Construction message={"This feature is under construction. Stay tuned!"} />
	);
};
